import { useState, useEffect } from 'react';
import {
  useToast,
  IconButton
} from '@chakra-ui/react';
import { FaFacebook } from 'react-icons/fa';

const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || "your-facebook-app-id";

const FacebookAuthButton = ({
  onSuccess,
  onError,
  isLoading = false
}) => {
  const [fbLoaded, setFbLoaded] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const toast = useToast();

  useEffect(() => {
    // Initialize Facebook SDK
    const initFacebookSDK = () => {
      if (window.FB) {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v18.0'
        });
        setFbLoaded(true);
      } else {
        // Wait for FB SDK to load
        window.fbAsyncInit = () => {
          window.FB.init({
            appId: FACEBOOK_APP_ID,
            cookie: true,
            xfbml: true,
            version: 'v18.0'
          });
          setFbLoaded(true);
        };
      }
    };

    initFacebookSDK();
  }, []);

  const handleFacebookLogin = () => {
    if (!window.FB || !fbLoaded) {
      toast({
        title: 'Facebook SDK not loaded',
        description: 'Please refresh the page and try again',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsAuthenticating(true);

    window.FB.login((response) => {
      setIsAuthenticating(false);

      if (response.authResponse) {
        // Successfully authenticated
        const { accessToken, userID } = response.authResponse;

        // Get user information
        window.FB.api('/me', { fields: 'id,name,email,first_name,last_name,picture' }, (userInfo) => {
          const facebookData = {
            accessToken,
            userID,
            ...userInfo
          };

          if (onSuccess) {
            onSuccess(facebookData);
          }
        });
      } else {
        // User cancelled login or error occurred
        const error = response.error || 'Facebook login was cancelled';
        console.error('Facebook Login Error:', error);

        toast({
          title: 'Facebook Sign-In Failed',
          description: 'Please try again or use manual registration',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });

        if (onError) {
          onError(error);
        }
      }
    }, {
      scope: 'email',
      return_scopes: true
    });
  };

  return (
    <IconButton
      icon={<FaFacebook />}
      onClick={handleFacebookLogin}
      isLoading={isLoading || isAuthenticating || !fbLoaded}
      size="md"
      width="48px"
      height="48px"
      bg="#1877F2"
      color="white"
      borderRadius="8px"
      border="1px solid"
      borderColor="#1877F2"
      aria-label="Sign in with Facebook"
      _hover={{
        bg: "#166FE5",
        borderColor: "#166FE5"
      }}
      _disabled={{
        opacity: 0.6,
        cursor: "not-allowed",
        _hover: {
          bg: "#1877F2"
        }
      }}
    />
  );
};

export default FacebookAuthButton;